export const HOME_URI = "/?ptype=homepage";
export const CHECKOUT_URI = "/checkout";
export const MOBILE_CHECKOUT_URI = "/mobilecheckout";
export const GDPR_INFO = "/gdprdata";
export const AUTH_URI = {
    PATH: "/authorization?authPage=",
    PARAM_KEY: "authPage",
    LOGIN_OPTIONS: "login-options",
    MOBILE_NUMBER_VERIFICATION: "verify-mobile-number",
    SIGN_UP: "sign-up-mobile",
    LOGIN_VIA_MOBILE: "login-mobile",

    LOGIN_VIA_EMAIL: "login-email",
    MERGE_ACCOUNTS: "merge-account",
};
